import { Extent } from '@models/api/Extent'
import { Bookmark as APIBookmark } from '@models/api/Bookmark'
import { Bookmark } from './Bookmark'
import { Dayjs } from 'dayjs'

export class ExtentBookmark extends Bookmark {
  constructor(
    id: string,
    name: string,
    public extent: Extent,
    creationTime?: Dayjs
  ) {
    super(id, name, creationTime)
  }

  static fromApiBookmark(
    bookmark: Bookmark,
    apiBookmark: APIBookmark
  ): ExtentBookmark | undefined {
    return new this(
      bookmark.id,
      bookmark.name,
      apiBookmark.EXTENT!,
      bookmark.creationTime
    )
  }
}
